import { combineReducers } from "redux";
import { searchParams } from "./searchparams";
import { searchStatus } from "./searchstatus";
import { flights } from "./flights";
import { selectedFlights } from "./selectedflights";
import { selectedFilters } from "./selectedfilters";
import { modal } from "./modal";
import { flightsTab } from "./flightstab";
import { createCheckout } from "./checkout/createcheckout";
import { offerTimeout } from "./offertimeout";
import { cancellation } from "./account/cancellation";
import { salespassengers } from "./account/salespassengersReducer";

const reducers = combineReducers({
	//parametros de busca e informações da busalespassengersReducersca
	searchParams,
	searchStatus,

	//todos os voos, voos selecionados, voos mais baratos e voos filtrados
	flights,
	selectedFlights,
	selectedFilters,

	//tab de voos
	flightsTab,

	//modal
	modal,

	//offer Timeout
	offerTimeout,

	//checkout
	createCheckout,

	//Cancelamento - Cancellation
	cancellation,

	//Dashboard vendas ofertante - cliente/vendas-por-passageiro
	salespassengers
});

export default reducers;
